import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { confirmPasswordReset } from "../lib/api";

export function ResetPasswordPage(props: { refreshSession: () => Promise<void> }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const token = params.get("token");
    if (!token) {
      setMessage("Missing reset token.");
      return;
    }

    try {
      await confirmPasswordReset(token, password);
      await props.refreshSession();
      setMessage("Password updated. Redirecting home...");
      window.setTimeout(() => navigate("/"), 900);
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Could not reset password.");
    }
  }

  return (
    <section className="form-panel auth-panel">
      <div className="section-heading">
        <p className="eyebrow">Reset password</p>
        <h1 className="compact-title">Choose a new password</h1>
      </div>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label>
          New password
          <input required minLength={8} maxLength={128} type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </label>
        <button type="submit" className="primary-link">
          Reset password
        </button>
      </form>
      {message ? <p className="status-message" role="status" aria-live="polite">{message}</p> : null}
    </section>
  );
}
